"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Category = require("./Category");

var _Category2 = _interopRequireDefault(_Category);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

var _renderFromData = require("./render-from-data");

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderBarNav = function (_React$Component) {
    (0, _inherits3.default)(SliderBarNav, _React$Component);
    (0, _createClass3.default)(SliderBarNav, [{
        key: "getOpenKeys",
        value: function getOpenKeys(openKeysProp) {
            var _this2 = this;

            if (!this.props.cascadeOpenKeys) {
                return openKeysProp;
            } else {
                var openKeysSet = new _set2.default();
                openKeysProp.forEach(function (key) {
                    openKeysSet.add(key);
                    // TODO: complete dataSource + cascadeOpenKeys
                    var parents = _this2.itemsParent.get(key);
                    if (parents) {
                        parents.forEach(function (key) {
                            return openKeysSet.add(key);
                        });
                    }
                });
                return [].concat((0, _toConsumableArray3.default)(openKeysSet));
            }
        }
    }]);

    function SliderBarNav(props) {
        (0, _classCallCheck3.default)(this, SliderBarNav);

        // TODO: is there a better algorithm?
        //  and this is a completely unnecessary, wrong requirement
        var _this = (0, _possibleConstructorReturn3.default)(this, (SliderBarNav.__proto__ || (0, _getPrototypeOf2.default)(SliderBarNav)).call(this, props));

        (0, _assign2.default)(_this, (0, _util.generateItemsSets)(_this.props.children));

        _this.state = {
            openKeys: _this.getOpenKeys(props.openKeys || props.defaultOpenKeys),
            selectedKeys: props.selectedKeys || props.defaultSelectedKeys,
            // widthCollapsed: !!props.collapsed,
            // layoutCollapsed: !!props.collapsed,
            collapsed: !!props.collapsed,
            expandingStyle: {},
            innerContentStyle: {}
        };

        _this.handleOpen = _this.handleOpen.bind(_this);
        _this.handleSelectOps = _this.handleSelectOps.bind(_this);
        _this.renderDataChildren = _renderFromData.renderDataChildren.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(SliderBarNav, [{
        key: "setStateAsync",
        value: function setStateAsync(updater) {
            var _this3 = this;

            return new _promise2.default(function (resolve, reject) {
                _this3.setState(updater, function () {
                    return resolve();
                });
            });
        }
    }, {
        key: "componentWillReceiveProps",
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextProps) {
                var innerDOM, _innerDOM, collapsedWidth, expandedWidth;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                // PROBLEM: does this guard actually work?
                                if (this.props.children != nextProps.children) {
                                    (0, _assign2.default)(this, (0, _util.generateItemsSets)(nextProps.children));
                                }

                                if (nextProps.openKeys && this.state.openKeys != nextProps.openKeys) {
                                    this.setState({ openKeys: this.getOpenKeys(nextProps.openKeys) });
                                }

                                if (Array.isArray(nextProps.selectedKeys) && this.state.selectedKeys != nextProps.selectedKeys) {
                                    this.setState({ selectedKeys: nextProps.selectedKeys });
                                }

                                // if I'm collapsing

                                if (!(nextProps.collapsed && !this.props.collapsed)) {
                                    _context.next = 17;
                                    break;
                                }

                                innerDOM = _reactDom2.default.findDOMNode(this.refs.navfoldInner);
                                _context.next = 7;
                                return this.setStateAsync({
                                    expandingStyle: { width: innerDOM.clientWidth }
                                });

                            case 7:
                                _context.next = 9;
                                return (0, _util.setTimeoutAsync)(1);

                            case 9:
                                _context.next = 11;
                                return this.setStateAsync({ collapsed: true });

                            case 11:
                                _context.next = 13;
                                return (0, _util.setTimeoutAsync)(1);

                            case 13:
                                _context.next = 15;
                                return this.setStateAsync({ expandingStyle: {} });

                            case 15:
                                _context.next = 32;
                                break;

                            case 17:
                                if (!(!nextProps.collapsed && this.props.collapsed)) {
                                    _context.next = 32;
                                    break;
                                }

                                _innerDOM = _reactDom2.default.findDOMNode(this.refs.navfoldInner);
                                collapsedWidth = _innerDOM.clientWidth;
                                _context.next = 22;
                                return this.setStateAsync({ collapsed: false });

                            case 22:
                                expandedWidth = _innerDOM.clientWidth;
                                _context.next = 25;
                                return this.setStateAsync({
                                    collapsed: true,
                                    expandingStyle: { width: collapsedWidth },
                                    innerContentStyle: { width: collapsedWidth }
                                });

                            case 25:
                                _context.next = 27;
                                return (0, _util.setTimeoutAsync)(1);

                            case 27:
                                _context.next = 29;
                                return this.setStateAsync({
                                    collapsed: false,
                                    expandingStyle: { width: expandedWidth },
                                    innerContentStyle: { width: expandedWidth }
                                });

                            case 29:
                                _context.next = 31;
                                return (0, _util.setTimeoutAsync)(192);

                            case 31:
                                this.setState({ expandingStyle: {}, innerContentStyle: {} });

                            case 32:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentWillReceiveProps(_x) {
                return _ref.apply(this, arguments);
            }

            return componentWillReceiveProps;
        }()
    }, {
        key: "handleOpen",
        value: function handleOpen(openKeys) {
            var _this4 = this;

            if (this.props.cascadeOpenKeys) {
                var openKeysSet = new _set2.default([].concat((0, _toConsumableArray3.default)(openKeys)));
                openKeys = openKeys.filter(function (key) {
                    var parents = _this4.itemsParent.get(key);
                    if (parents) {
                        return parents.every(function (pkey) {
                            return openKeysSet.has(pkey);
                        });
                    } else {
                        return true;
                    }
                });
            }

            if (!this.props.openKeys) {
                this.setState({ openKeys: openKeys });
            }
            this.props.onOpen && this.props.onOpen(openKeys);
        }
    }, {
        key: "handleSelectOps",
        value: function handleSelectOps(key, instance) {
            switch (this.props.selectMode) {
                case "single":
                    {
                        var newKeys = [key];
                        this.setState({ selectedKeys: newKeys });
                        this.props.onSelect && this.props.onSelect(newKeys, instance);
                        break;
                    }
                case "multiple":
                    {
                        var isDeselect = this.state.selectedKeys.indexOf(key) != -1;
                        var _newKeys = this.state.selectedKeys.filter(function (k) {
                            return k != key;
                        });
                        if (!isDeselect) {
                            _newKeys.push(key);
                        }
                        this.setState({ selectedKeys: _newKeys });
                        this.props.onSelect && this.props.onSelect(_newKeys, instance);
                        break;
                    }
                default:
                    break;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this5 = this;

            var openKeysSet = new _set2.default(this.state.openKeys);
            var selectedKeysSet = new _set2.default(this.state.selectedKeys);

            // console.info(this.state.openKeys);
            var _props = this.props,
                width = _props.width,
                collapsed = _props.collapsed,
                openKeys = _props.openKeys,
                defaultOpenKeys = _props.defaultOpenKeys,
                onOpen = _props.onOpen,
                cascadeOpenKeys = _props.cascadeOpenKeys,
                selectedKeys = _props.selectedKeys,
                defaultSelectedKeys = _props.defaultSelectedKeys,
                selectMode = _props.selectMode,
                onSelect = _props.onSelect,
                textIcon = _props.textIcon,
                dataSource = _props.dataSource,
                dataRenderCallback = _props.dataRenderCallback,
                itemOnClick = _props.itemOnClick,
                className = _props.className,
                style = _props.style,
                others = (0, _objectWithoutProperties3.default)(_props, ["width", "collapsed", "openKeys", "defaultOpenKeys", "onOpen", "cascadeOpenKeys", "selectedKeys", "defaultSelectedKeys", "selectMode", "onSelect", "textIcon", "dataSource", "dataRenderCallback", "itemOnClick", "className", "style"]);

            var classNameFinal = (0, _classnames2.default)("cn-navfold-inner",
            // this.state.widthCollapsed ? "cn-navfold-collapsed-width" : "cn-navfold-expanded-width",
            // this.state.layoutCollapsed ? "cn-navfold-collapsed-layout" : "cn-navfold-expanded-layout",
            this.state.collapsed ? "cn-navfold-collapsed" : "cn-navfold-expanded", className);

            if (collapsed) {
                this.state.selectedKeys.forEach(function (key) {
                    var parents = _this5.itemsParent.get(key) || [];
                    if (parents.length) {
                        selectedKeysSet.add(parents[0]);
                    }
                });
            }

            var propagate = {
                collapsed: this.state.collapsed,
                openKeys: this.state.openKeys,
                onOpen: this.handleOpen,
                openKeysSet: openKeysSet,
                selectedKeysSet: selectedKeysSet,
                onSelectOps: this.handleSelectOps,
                itemsChild: this.itemsChild,
                textIcon: this.props.textIcon,
                dataRenderCallback: this.props.dataRenderCallback,
                itemOnClick: this.props.itemOnClick
            };

            return _react2.default.createElement(
                "div",
                (0, _extends3.default)({
                    className: classNameFinal,
                    ref: "navfoldInner"
                }, others, {
                    style: (0, _assign2.default)({}, this.state.expandingStyle, style)
                }),
                _react2.default.createElement(
                    "div",
                    { className: "cn-navfold-section-content", style: this.state.innerContentStyle },
                    _react2.default.createElement(
                        "div",
                        { className: "cn-navfold-section-content-inner" },
                        _react2.default.Children.map(this.renderDataChildren(), function (n) {
                            return (0, _Category.renderItemRoot)(n, propagate);
                        }),
                        _react2.default.Children.map(this.props.children, function (n) {
                            return (0, _Category.renderItemRoot)(n, propagate);
                        })
                    )
                )
            );
        }
    }]);
    return SliderBarNav;
}(_react2.default.Component);

SliderBarNav.propTypes = {
    className: _propTypes2.default.string,
    collapsed: _propTypes2.default.bool,
    openKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
    defaultOpenKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
    cascadeOpenKeys: _propTypes2.default.bool,
    onOpen: _propTypes2.default.func,
    selectedKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
    defaultSelectedKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
    selectMode: _propTypes2.default.oneOf(["single", "multiple"]),
    onSelect: _propTypes2.default.func,
    textIcon: _propTypes2.default.bool,

    dataSource: _propTypes2.default.arrayOf(_propTypes2.default.object),
    dataRenderCallback: _propTypes2.default.func,
    itemOnClick: _propTypes2.default.func
    // itemGetChildren: PropTypes.func
};
SliderBarNav.defaultProps = {
    collapsed: false,
    className: null,
    defaultOpenKeys: [],
    defaultSelectedKeys: [],
    selectMode: "single",
    cascadeOpenKeys: false,
    dataRenderCallback: _renderFromData.defaultDataRenderCallback
};
exports.default = SliderBarNav;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/SliderBarNav.js
// module id = 736
// module chunks = 0